<script setup lang="ts">
import { Sun, Moon } from 'lucide-vue-next'

import BaseIcon from '@/components/BaseIcon.vue'
import { useResume } from '@/composables/useResume'
import { useTheme } from '@/composables/useTheme'
import { useLocale } from '@/composables/useLocale'

interface Props {
  /** Навбар поджимается, когда страница прокручена. */
  scrolled: boolean
}

defineProps<Props>()

const { content } = useResume()
const { theme, toggle: toggleTheme } = useTheme()
const { locale, toggle: toggleLocale } = useLocale()

const SECTION_IDS = ['about', 'experience', 'skills', 'projects', 'education', 'contact'] as const
</script>

<template>
  <nav class="nav glass" :class="{ scrolled }">
    <div class="nav-logo">
      <span class="dot"></span>
      <span>{{ locale === 'ru' ? 'Умар М.' : 'Umar M.' }}</span>
    </div>
    <div class="nav-links">
      <a v-for="id in SECTION_IDS" :key="id" :href="`#${id}`">{{ content.nav[id] }}</a>
    </div>
    <div class="nav-tools">
      <button class="toggle lang" type="button" aria-label="Language" @click="toggleLocale">
        {{ locale.toUpperCase() }}
      </button>
      <button class="toggle icon" type="button" aria-label="Theme" @click="toggleTheme">
        <BaseIcon :icon="theme === 'dark' ? Sun : Moon" :size="17" />
      </button>
    </div>
  </nav>
</template>
